import { navItems } from "@/lib/site-content";

export type MenuItem = {
  id: number;
  href: string;
  zhLabel: string;
  enLabel: string;
  visible: boolean;
  order: number;
  parentId?: number | null;
};

const enLabels = ["Home", "About", "Products", "Capabilities", "Industries", "Knowledge", "Resources", "Calculator", "Trust Center", "RFQ"];

export const defaultMenuItems: MenuItem[] = navItems.map((item, index) => ({
  id: index + 1,
  href: item.href,
  zhLabel: item.label,
  enLabel: enLabels[index] ?? item.label,
  visible: true,
  order: index + 1,
  parentId: null,
}));

export function menuItemsForLang(items: MenuItem[], lang: "zh" | "en") {
  const visibleItems = items
    .filter((item) => item.visible)
    .sort((a, b) => a.order - b.order)
    .map((item) => ({
      id: item.id,
      parentId: item.parentId ?? null,
      href: lang === "zh" ? item.href : item.href === "/" ? "/en" : `/en${item.href}`,
      label: lang === "zh" ? item.zhLabel : item.enLabel,
    }));

  return visibleItems
    .filter((item) => !item.parentId)
    .map((item) => ({
      id: item.id,
      href: item.href,
      label: item.label,
      children: visibleItems
        .filter((child) => child.parentId === item.id)
        .map((child) => ({ id: child.id, href: child.href, label: child.label })),
    }));
}
